<template>
  <div class="document">
    <h5 class="title is-5 has-text-left">
      Quick Actions
    </h5>
    <ul>
      <li
        v-for="(action, index) in actions"
        :key="index"
      >
        <router-link
          v-if="!action.isHidden"
          :to="{ name: action.to }"
        >
          <div class="action-icon-box">
            <font-awesome-icon
              size="lg"
              :icon="action.icon"
              :title="action.label"
            />
          </div>
          <span class="has-text-left">
            {{ action.label }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
  faCheckCircle,
  faSearchPlus,
} from '@fortawesome/pro-regular-svg-icons';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faPlus,
  faCheckCircle,
  faSearchPlus,
);
export default {
  mixins: [
    PermissionManager,
  ],
  data() {
    return {
      actions: [],
    };
  },
  created() {
    this.actions = [
      {
        label: 'Upload a File',
        icon: ['far', 'check-circle'],
        to: 'matchOptionsPersonId',
        isHidden: !this.hasModule('PRSID:MATCH:OPTIONS:UPLOADFILE'),
      },
      {
        label: 'Perform a Search',
        icon: ['far', 'search-plus'],
        to: 'PidSearch',
        isHidden: !this.hasModule('PRSID:SRCH:OPTIONS:VIEW'),
      },
      {
        label: 'Add a Person',
        icon: ['far', 'plus'],
        to: 'pidAddPerson',
        isHidden: !this.hasModule('PRSID:MATCH:OPTIONS:PRSN:ADD'),
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
  .document
    padding: 1rem
    height: 100%
  .title
    margin-bottom: 0.5rem
  ul
    padding-left: 1rem
  li
    min-height: 30px
    padding: 0.25rem 0 0.25rem
    display: flex
    align-items: center
  a
    display: flex
    width: 100%
  .action-icon-box
    min-width: 25px
    margin-right: 0.5rem
    display: flex
    justify-content: center
    align-items: center
</style>
